import React from 'react';
import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

const Escalations = () => {
  const { t } = useTranslation();

  return (
    <Result
      status="info"
      title={t('escalations_coming_soon') || 'Escalations Feature Coming Soon'}
      subTitle={t('escalations_desc') || 'This feature is currently under development.'}
    />
  );
};

export default Escalations;
